import React from 'react'
import FechaFunction from '@app/functions/FechaFunction';
import { useNavigate } from 'react-router-dom';

function LogsTicketOld({
    item,
    type,
    handleClose,
    isLast
}) {
    const navigate = useNavigate();
    const redirect = ()=>{
        if(handleClose){
            handleClose()
        }
        navigate(`/tickets/${item.id_tk}/ver`)
    }

    const isClosed = item && item.cerrado_tk;
    const fechaDisplay = isClosed
        ? FechaFunction.format(new Date(item.cerrado_tk), 'dd/MM/yyyy HH:mm')
        : FechaFunction.format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm');

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: isLast ? 0 : '10px',
                minWidth: 0,
                overflow: 'hidden'
            }}
        >
            {/* Dot */}
            <div
                style={{
                    width: '22px',
                    height: '22px',
                    borderRadius: '50%',
                    background: isClosed ? '#adb5bd' : '#c0392b',
                    border: '2px solid #fff',
                    outline: `1px solid ${isClosed ? '#adb5bd' : '#c0392b'}`,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '12px',
                    marginTop: '3px',
                    zIndex: 1
                }}
            >
                <i
                    className={isClosed ? 'fas fa-lock' : 'fas fa-circle'}
                    style={{color: '#fff', fontSize: '7px'}}
                />
            </div>

            {/* Fila */}
            <div
                role="button"
                tabIndex={0}
                onClick={redirect}
                onKeyDown={(e) => e.key === 'Enter' && redirect()}
                style={{
                    flex: 1,
                    minWidth: 0,
                    background: '#fff',
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    overflow: 'hidden'
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#f1f3f5'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
            >
                <div
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px'}}
                >
                    <span style={{fontWeight: 600, fontSize: '0.82rem', color: '#343a40', flexShrink: 0}}>
                        Ticket #
                        {item.id_tk}
                    </span>
                    <span
                        className={`badge badge-${isClosed ? 'secondary' : 'danger'}`}
                        style={{fontSize: '0.7rem', fontWeight: 500, flexShrink: 0}}
                    >
                        {isClosed ? 'Cerrado' : 'Abierto'}
                    </span>
                </div>
                <p
                    className="mb-0 text-muted"
                    style={{
                        fontSize: '0.8rem',
                        marginTop: '2px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {item.titulo_tk}
                </p>
                <small className="text-muted">
                    <i className="far fa-clock mr-1" />
                    {fechaDisplay}
                </small>
            </div>
        </div>
    )
}

LogsTicketOld.defaultProps = {
    canShowMore: false,
    buttons: null,
    isLast: false,
};

export default LogsTicketOld;
